/**
 * Check if an input value is null or undefined
 * @param value: input value
 */
export function isNOU(value: unknown): boolean {
	return (value === null || value === undefined);
}
